const navReducer = (state = {
  'header-external-links': {
    'some-label': '',
    statics: [],
  },
  'main-navigation': [],
  subcategories: [],
  activeSubCategories: {},
  activeCategoryId: '',
}, action) => {
  switch (action.type) {
    case 'GET_NAV':
      return {
        ...state,
        ...action.nav,
      };
    case 'SET_SUBCATEGORIES':
      return {
        ...state,
        subcategories: action.subcategories,
      };
    case 'SET_ACTIVE_CATEGORY_ID':
      return {
        ...state,
        activeCategoryId: action.activeCategoryId,
      };
    case 'SET_ACTIVE_CATEGORY':
      return {
        ...state,
        activeCategory: action.activeCategory,
      };
    case 'SET_ACTIVE_SUBCATEGORIES':
      return {
        ...state,
        activeSubCategories: action.activeSubCategories,
      };
    default:
      return {
        ...state,
      };
  }
};

export default navReducer;



// WEBPACK FOOTER //
// ./frontend/js/Base/Reducers/navReducer.jsx